"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(idx, openinghours, lang) {
  var groups = [];
  var items = [];
  var isOpen = '';
  var d = new Date();
  var day_description = '';
  var day_title = '';
  var timeslot_description = '';
  var timeslot_title = '';
  var times = [];
  var beginTime = new Date();
  beginTime.setHours(0, 0, 0, 0);
  var endTime = new Date();
  endTime.setHours(23, 59, 59, 999);
  var dateLanguage = "en-us";
  var monthNumeric = new Date().toLocaleString(dateLanguage, {
    month: "numeric"
  });
  var year = new Date().toLocaleString(dateLanguage, {
    year: "numeric"
  });
  var otherThanNull = Object.values(openinghours[idx].week).some(function (el) {
    return el !== "";
  });

  if (otherThanNull) {
    var _loop = function _loop(i) {
      var _groups$push;

      var newday = ''; // Because sunday is technically day "0", we use this instead of the other algoritm

      if (d.getDay() === 0 && i === 0) {
        newday = new Date(d.setDate(d.getDate() - 6));
      } else {
        newday = newday = new Date(d.setDate(d.getDate() - d.getDay() + i + 1));
      }

      var date = newday.toLocaleString(dateLanguage, {
        day: "2-digit",
        weekday: "long",
        month: "short",
        year: "numeric"
      }); // let monthNumeric = Number(newday.toLocaleString(dateLanguage, { month: "numeric" })) - 1;

      date = date.replace(/,/g, "");
      date = date.split(" ");
      var today = new Date().getDate();
      groups.push((_groups$push = {
        date: date[2],
        month: date[1],
        monthNumeric: monthNumeric - 1,
        weekday: date[0].toLowerCase(),
        year: year,
        id: date[2]
      }, _defineProperty(_groups$push, "id", i), _defineProperty(_groups$push, "title", (0, _idbReactTranslations["default"])(date[0].toLowerCase(), lang) + ' ' + date[2] + ' ' + (0, _idbReactTranslations["default"])(date[1].toLowerCase(), lang)), _defineProperty(_groups$push, "isRoot", true), _defineProperty(_groups$push, "hasChildren", Object.values(openinghours[idx].week)[i].items && Object.values(openinghours[idx].week)[i].items.length > 0 ? true : false), _groups$push));

      if (Object.values(openinghours[idx].week)[i].is_closed === true) {
        if (Number(date[2]) === new Date().getDate()) {
          isOpen = 'closed';
        }
      } else if (Object.values(openinghours[idx].week)[i].appointment_only && Object.values(openinghours[idx].week)[i].hours.length === 0) {
        items.push({
          id: "".concat(i),
          group: i,
          title: (0, _idbReactTranslations["default"])('appointment', lang),
          start_time: beginTime.getTime() + 3600000,
          end_time: endTime.getTime() - 3600000,
          className: "".concat(Number(date[2]) === today ? isOpen : ''),
          onMouseDown: function onMouseDown(e) {
            return console.log(e);
          },
          itemProps: {
            'data-custom-attribute': 'Random content',
            'aria-hidden': true,
            style: {
              background: "var(--grey-50)",
              textAlign: 'center',
              overflow: 'hidden',
              border: 'none',
              color: 'white',
              borderRadius: '3px'
            }
          }
        });
      } else if (Object.values(openinghours[idx].week)[i].hours && Object.values(openinghours[idx].week)[i].hours.length > 0) {
        if (typeof Object.values(openinghours[idx].week)[i].hours !== 'string') {
          var hours = Object.values(openinghours[idx].week)[i].hours;

          for (var j = 0; j < hours.length; j++) {
            var hour = Object.values(openinghours[idx].week)[i].hours[j];
            var start = new Date(year, monthNumeric - 1, Number(date[2]), hour.from.substring(2, 0), hour.from.charAt(3) + hour.from.charAt(4));
            var end = new Date(year, monthNumeric - 1, Number(date[2]), hour.to.substring(2, 0), hour.to.charAt(3) + hour.to.charAt(4));
            var now = new Date();

            if (Number(date[2]) === now.getDate()) {
              day_description = Object.values(openinghours[idx].week)[i].message;
              day_title = (0, _idbReactTranslations["default"])(date[0].toLowerCase(), lang) + ' ' + date[2] + ' ' + (0, _idbReactTranslations["default"])(date[1].toLowerCase(), lang);

              if (start.getTime() - now.getTime() <= 3600000 && start.getTime() - now.getTime() > 0) {
                isOpen = 'almostOpen';
                break;
              }

              if (end.getTime() - now.getTime() <= 3600000 && end.getTime() - now.getTime() > 0) {
                isOpen = 'almostClosed';
                break;
              } // Check if it is open or closed
              else if (start <= now && now < end && now.getDate() === start.getDate()) {
                isOpen = 'open';
                break;
              } else {
                isOpen = 'closed';
              }
            }
          }

          hours.forEach(function (hour, j) {
            var start = new Date(year, monthNumeric - 1, today, hour.from.substring(2, 0), hour.from.charAt(3) + hour.from.charAt(4));
            var end = new Date(year, monthNumeric - 1, today, hour.to.substring(2, 0), hour.to.charAt(3) + hour.to.charAt(4));
            times.push(hour);
            items.push({
              id: "".concat(i, " + ").concat(j),
              group: i,
              // group: i,
              title: hour.from.substring(0, 5) + ' - ' + hour.to.substring(0, 5),
              start_time: start.getTime(),
              end_time: end.getTime(),
              className: "".concat(start.getTime(), " ").concat(end.getTime(), " ").concat(Number(date[2]) === today ? isOpen : ''),
              itemProps: {
                'data-custom-attribute': 'qsdfqsdf',
                'aria-hidden': true,
                style: {
                  background: "var(--grey-50)",
                  textAlign: 'center',
                  overflow: 'hidden',
                  border: 'none',
                  color: 'white',
                  borderRadius: '3px'
                }
              }
            });
          });
        }
      } else {
        var title = Object.values(openinghours[idx].week)[i].message;
        items.push({
          id: "".concat(i, " + 0"),
          group: i,
          title: title,
          start_time: beginTime.getTime() + 3600000,
          end_time: endTime.getTime() - 3600000,
          className: "".concat(Number(date[2]) === today ? isOpen : ''),
          itemProps: {
            'data-custom-attribute': 'Random content',
            'aria-hidden': true,
            style: {
              background: "var(--grey-50)",
              textAlign: 'center',
              overflow: 'hidden',
              border: 'none',
              color: 'white',
              borderRadius: '3px'
            }
          }
        });
      }

      if (Object.values(openinghours[idx].week)[i].items && Object.values(openinghours[idx].week)[i].items.length > 0) {
        for (var index = 0; index < Object.values(openinghours[idx].week)[i].items.length; index++) {
          var item = Object.values(openinghours[idx].week)[i].items[index];
          times.push({
            from: item.from,
            to: item.to
          });

          var _start = new Date(year, monthNumeric - 1, today, item.from.substring(2, 0), item.from.charAt(3) + item.from.charAt(4));

          var _end = new Date(year, monthNumeric - 1, today, item.to.substring(2, 0), item.to.charAt(3) + item.to.charAt(4));

          var _now = new Date();

          var isOpenSub = '';

          for (var indexx = 0; indexx < Object.values(openinghours[idx].week)[i].items.length; indexx++) {
            if (Number(date[2]) === _now.getDate()) {
              if (_start.getTime() - _now.getTime() <= 3600000 && _start.getTime() - _now.getTime() > 0) {
                isOpenSub = 'almostOpen';
                timeslot_description = item.desc;
                timeslot_title = item.title;
                break;
              }

              if (_end.getTime() - _now.getTime() <= 3600000 && _end.getTime() - _now.getTime() > 0) {
                isOpenSub = 'almostClosed';
                timeslot_description = item.desc;
                timeslot_title = item.title;
                break;
              } // Check if it is open or closed
              else if (_start <= _now && _now < _end && _now.getDate() === _start.getDate()) {
                isOpenSub = 'open';
                timeslot_description = item.desc;
                timeslot_title = item.title;
                break;
              } else {
                isOpenSub = 'closed';
                timeslot_description = item.desc;
                timeslot_title = item.title;
              }
            }
          }

          groups.push({
            date: date[2],
            month: date[1],
            monthNumeric: monthNumeric - 1,
            weekday: date[0].toLowerCase(),
            year: year,
            id: "".concat(i) + "".concat(index),
            title: item.title,
            isRoot: false,
            parent: i,
            url: item.link,
            key: index,
            isOpenSub: isOpenSub
          });
          items.push({
            id: "".concat(i) + "".concat(index),
            group: "".concat(i) + "".concat(index),
            title: item.from.substring(0, 5) + ' - ' + item.to.substring(0, 5),
            start_time: _start.getTime(),
            end_time: _end.getTime(),
            url: item.link,
            className: "".concat(Number(date[2]) === today ? isOpenSub : '', " subTimeSlot"),
            itemProps: {
              'data-custom-attribute': 'Random content',
              'aria-hidden': true,
              style: {
                background: "var(--grey-50)",
                textAlign: 'center',
                overflow: 'hidden',
                border: 'none',
                color: 'white',
                borderRadius: '3px',
                cursor: 'default'
              }
            }
          });
        }
      }
    };

    for (var i = 0; i < Object.keys(openinghours[idx].week).length; i++) {
      _loop(i);
    }
  }

  var lowest = Math.min.apply(Math, times.map(function (o) {
    var low = new Date(beginTime.getFullYear(), beginTime.getMonth(), beginTime.getDate(), Number(o.from.substring(2, 0), o.from.charAt(3) + o.from.charAt(4)), Number(o.from.substring(5, 3), o.from.charAt(3) + o.from.charAt(4)));
    return low;
  }));
  var highest = Math.max.apply(Math, times.map(function (o) {
    var high = new Date(beginTime.getFullYear(), beginTime.getMonth(), beginTime.getDate(), Number(o.to.substring(2, 0), o.to.charAt(3) + o.to.charAt(4)), Number(o.to.substring(5, 3), o.to.charAt(3) + o.to.charAt(4)));
    return high;
  }));
  items = items.sort(function (a, b) {
    return b - a;
  });
  return {
    groups: groups,
    items: items,
    isOpen: isOpen,
    lowest: lowest,
    highest: highest,
    day_description: day_description,
    day_title: day_title,
    timeslot_description: timeslot_description,
    timeslot_title: timeslot_title,
    otherThanNull: otherThanNull
  };
}